<div class="label-container" *ngIf="label"><label [for]="name"> {{ getLabel()}}</label></div>

<div class="border">
    <input [type]="type"
           class="input"
           [name]="name"
           [id]="name"
           [disabled]="isDisabled"
           [placeholder]="placeholder || ''"
           [autocomplete]="autocomplete"
           [(ngModel)]="value"
           (ngModelChange)="onNgModelChanged()"
           #inputElement
           (blur)="onBlur(inputElement)"
           (focus)="onFocus()">
</div>
